import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { SecureContext } from './components/home/Security'

ReactDOM.render(<SecureContext><App /></SecureContext>, document.getElementById('root'));

registerServiceWorker();
